export * from './src/data.view.widget'
export * from './src/data.view.widget.fixture'
export * from './src/simple.data.view.widget.layout'

